/**
 * @author 戴旭
 * @createDate 2023/03/01 16:22:43
 * @updateDate 2023/03/01 16:22:43
 * @description: 辖区管理系统设置
 */

const systemSettingRouter = [

  // 职位管理
  {
    path: '/jurisdictionSystem/job-manage',
    name: 'jobManage',
    component: () =>
      import(
        /*webpackChunkName:"job" */
        // '@/views/jurisdictionSystem/job/Manage.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/job-manage/Page.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '职位管理'
    }
  },


  // 编辑职位
  {
    path: '/jurisdictionSystem/job-edit/:jobId',
    name: 'jobEdit',
    component: () =>
      import(
        /*webpackChunkName:"job" */
        // '@/views/jurisdictionSystem/job/Edit.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/job-manage/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '编辑职位',
      breadcrumb: [
        {
          title: '职位管理',
          name: 'jobManage'
        }
      ]
    }
  },


  // 添加职位
  {
    path: '/jurisdictionSystem/job-add',
    name: 'jobAdd',
    component: () =>
      import(
        /*webpackChunkName:"job" */
        // '@/views/jurisdictionSystem/job/Edit.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/job-manage/Add.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '添加职位',
      breadcrumb: [
        {
          title: '职位管理',
          name: 'jobManage'
        }
      ]
    }
  },


  // 人员字段管理列表
  {
    path: '/jurisdictionSystem/personnel-field',
    name: 'personnelField',
    component: () =>
      import(
        /*webpackChunkName:"personnelField" */
        // '@/views/jurisdictionSystem/personnelField/List.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/peopel-field-manage/Page.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '人员字段管理'
    }
  },


  // 人员字段编辑
  {
    path: '/jurisdictionSystem/personnel-field-edit/:meta_type/:id',
    name: 'personnelFieldEdit',
    component: () =>
      import(
        /*webpackChunkName:"personnelField" */
        '@/views/jurisdiction-manage/system-settings/sys-config/peopel-field-manage/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加字段',
        breadcrumb: [
          {
            title: '人员字段管理',
            name: 'personnelField'
          }
        ]
      },
      2: {
        title: '编辑字段',
        breadcrumb: [
          {
            title: '人员字段管理',
            name: 'personnelField'
          }
        ]
      }
    }
  },


  // 共岗功能配置
  {
    path: '/jurisdictionSystem/share-quarter-setting',
    name: 'jurisdictionShareQuarterSetting',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/ShareQuarterSetting'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/total-duty/Page.vue'
        ),
    meta: {
      SecondaryMenu: '共岗功能配置', //二级菜单
      title: '共岗功能配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },


  // 关联关系相关配置
  {
    path: '/jurisdictionSystem/incidence-relation-set',
    name: 'jurisdictionSystemIncidenceRelationSet',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/target/IncidenceRelationSer.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/incidence-relation/Page.vue'
        ),
    meta: {
      title: '关联关系相关配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },

   // 岗位编辑配置 （辖区管理）
   {
    path: '/jurisdictionSystem/jobEditingConfig',
    name: 'jurisdictionSystemJobEditingConfig',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/job-config/Page'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '岗位编辑配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting',
        },
      ],
    },
  },
  // 关联关系生效时间配置
  {
    path: '/jurisdictionSystem/incidence-relation-datetime-set',
    name: 'incidenceRelationDateTimeSet',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        '@/views/jurisdiction-manage/index-manage/incidence-relation-date-time-set/Page.vue'
        ),
    meta: {
      SecondaryMenu: '关联关系生效时间配置', //二级菜单
      title: '关联关系生效时间配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting',
        },
      ],
    },
  },

  // 关联关系生效时间配置
  {
    path: '/jurisdictionSystem/incidence-relation-datetime-set',
    name: 'incidenceRelationDateTimeSet',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        '@/views/jurisdiction-manage/index-manage/incidence-relation-date-time-set/Page.vue'
        ),
    meta: {
      SecondaryMenu: '关联关系生效时间配置', //二级菜单
      title: '关联关系生效时间配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting',
        },
      ],
    },
  },



  // 销售指标分配设置
  {
    path: '/jurisdictionSystem/sales-target-setting',
    name: 'jurisdictionSystemSalesTargetSetting',
    component: () =>
      import(
        /*webpackChunkName:"jurisdictionSystemTarget" */
        // '@/views/jurisdictionSystem/target/SalesTargetSetting.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/sale-index-config/Page.vue'
        ),
    meta: {
      SecondaryMenu: '指标分配', //二级菜单
      title: '销售指标分配设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },


  // 销售指标显示设置 （辖区管理）
  {
    path: '/jurisdictionSystem/SalesIndicatorDisplaySettings',
    name: 'jurisdictionSystemSalesIndicatorDisplaySettings',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/target/SalesIndicatorDisplaySettings.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/sale-index-display-config/Page.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '销售指标显示设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },


  // 销售指标规则设置 （辖区管理）
  {
    path: '/jurisdictionSystem/rule-settings',
    name: 'jurisdictionSystemRuleSettings',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/newSaleindex/RuleSettings.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/sale-index-rules-config/Page.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '销售指标规则设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },


  // 销售指标规则设置 编辑规则
  {
    path: '/jurisdictionSystem/rule-edit/:sale_index_rule_id',
    name: 'jurisdictionSystemRuleEdit',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/newSaleindex/RuleEdit.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/sale-index-rules-config/Edit.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增规则 ',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        },
        {
          title: '销售指标规则设置',
          name: 'jurisdictionSystemRuleSettings'
        }
      ]
    }
  },


  // APP追加绑定次数设置
  {
    path: '/jurisdictionSystem/AppendBinding',
    name: 'jurisdictionSystemAppendBinding',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/target/AppendBinding.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/app-bind-config/Page.vue'
        ),
    meta: {
      title: 'APP追加绑定次数设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },


  // 签约量导入
  {
    path: '/jurisdictionSystem/ContractedVolume',
    name: 'jurisdictionSystemContractedVolume',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        // '@/views/jurisdictionSystem/target/ContractedVolume.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/colume-import/Import.vue'
        ),
    meta: {
      title: '签约量导入',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },

   // 关系成员映射表
   {
    path: '/jurisdictionSystem/RelationShipMapping',
    name: 'jurisdictionSystemRelationShipMapping',
    component: () =>
      import(
        /*webpackChunkName:"departmentLabel" */
        '@/views/jurisdiction-manage/system-settings/sys-config/sys-configs/relationship-member-mapping/Page.vue'
        ),
    meta: {
      title: '关系成员映射表',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'jurisdictionSystemMdSetting'
        }
      ]
    }
  },


  // 操作日志 辖区管理
  {
    path: '/jurisdictionSystem/operation-log/:meta_type',
    name: 'jurisdictionOperationLog',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        // '@/views/masterDataSystem/OperationLog.vue'
        '@/views/jurisdiction-manage/system-settings/sys-config/log/Page.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作日志'
    }
  }


];

export default systemSettingRouter;